module.exports = __webpack_public_path__ + "img/operating_records_tl.4eba477c.svg";